import { render, staticRenderFns } from "./Infos.vue?vue&type=template&id=50e25618&scoped=true&"
import script from "./Infos.vue?vue&type=script&lang=js&"
export * from "./Infos.vue?vue&type=script&lang=js&"
import style0 from "./Infos.vue?vue&type=style&index=0&id=50e25618&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e25618",
  null
  
)

export default component.exports